<template>
  <div>
    <v-container>
      <v-row>
        <v-col lg="12">
          <div class="section-title text-center mb--20 mb_sm--0 mb_md--0">
            <h2 class="heading-title">Prensa</h2>
            <p>
              Artículos desde la fuente
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- Start Portfolio Activation  -->
    <VueSlickCarousel
        v-bind="settings"
        class="rn-slick-activation portfolio-slick-activation item-fluid slick-dotted rn-slick-dot mt--40 mt_sm--40"
    >
      <!-- Start Single Portfolio  -->
      <div class="portfolio" v-for="(item, i) in postList" :key="i">
        <div class="thumbnail-inner">
          <v-img class="thumbnail v-image__image--cover" :src="item.src"></v-img>
          <v-img class="bg-blr-image v-image__image--cover" :src="item.src"></v-img>
        </div>
        <div class="content">
          <div class="inner">
            <p>{{ item.meta }}</p>
            <h4>
              <router-link :to="`blog/${item.slug}`">{{ item.title }}</router-link>
            </h4>
            <div class="portfolio-button">
              <router-link class="rn-btn" :to="`blog/${item.slug}`">Leer más</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <!-- End Single Portfolio  -->
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import {container} from "@/main";
import {PostsService} from "@/pages/blog/posts.service";
import config from "@/config/config";

export default {
  components: {
    VueSlickCarousel,
  },
  methods: {
    decodeHtml(html) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      return textarea.value;
    },
  },
  async created() {
    this.postService = container.get(PostsService);
    const posts = await this.postService.getLastPosts();
    this.postList = [];
    for(const post of posts) {
      let categoryName = null;
      for(const category in config.categories) {
        if(config.categories[category].id === post.categories[0]) {
          categoryName = config.categories[category].name;
          break;
        }
      }
      this.postList.push({
        src: post.jetpack_featured_media_url,
        meta: categoryName,
        title: this.decodeHtml(post.title.rendered),
        link: post.link,
        slug: post.slug,
        id: post.id,
      });
    }
  },
  data() {
    return {
      postList: [
        {
          src: require("../../../assets/images/portfolio/portfolio-1.jpg"),
          meta: "Development",
          title: "You can see your Portfolio",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-2.jpg"),
          meta: "Html",
          title: "Getting tickets to the big show",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-3.jpg"),
          meta: "Graphic",
          title: "You can see your Portfolio",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-4.jpg"),
          meta: "Freelancer",
          title: "You can see your Portfolio",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-5.jpg"),
          meta: "Freelancer",
          title: "The Language of Developer",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-6.jpg"),
          meta: "Freelancer",
          title: "You can see your Portfolio",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-7.jpg"),
          meta: "App Development",
          title: "The Language of Developer",
        },
        {
          src: require("../../../assets/images/portfolio/portfolio-8.jpg"),
          meta: "Freelancer",
          title: "You can see your Portfolio",
        },
      ],
      // for all works
      settings: {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,

        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 1263,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      },
    };
  },
};
</script>
